import { ProductEmailInvitation } from "@/components/product-email-invitation";
import { NavMenu } from "@/components/nav-menu";
import { hasSidebarLayout } from "@/lib/app-layout";
import { isAuthenticated } from "@/lib/is-authenticated";
import { Outlet, createFileRoute, useMatches } from "@tanstack/react-router";

function RouteComponent() {
  const matches = useMatches();
  const sidebarLayoutIsActive = hasSidebarLayout(matches);

  return (
    <>
      <NavMenu />
      {!sidebarLayoutIsActive && <ProductEmailInvitation />}
      <Outlet />
    </>
  );
}

export const Route = createFileRoute("/_app")({
  beforeLoad: isAuthenticated,
  component: RouteComponent,
});
